import { IconName } from '@infotech-soe/erp-ui-kit';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';

import CategoryCommand, { RefreshStrategy } from './CategoryCommand';

class LinkedFilesCommand extends CategoryCommand<Record<string, any>> {
  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.LINKED_FILES,
    };
  }

  public getIcon(): IconName {
    return 'attach-file';
  }

  public getRefreshStrategy(): RefreshStrategy {
    return RefreshStrategy.NONE;
  }
}

export default LinkedFilesCommand;
